import * as Yup from "yup";

export const schema = (messages: any) => Yup.object().shape({
    name: Yup.string().required(messages['specificationAttributes.edit.option.nameRequired'].toString()),
});